import { uniq } from 'lodash'

import { venueSettingsModals } from 'components/VenueSettings/resources'
import { SETTINGS_LEVELS } from 'resources'
import settingsUtils from 'utils/settings'

const handleClickCustomTipConfiguration = (setModalType) => () =>
  setModalType(venueSettingsModals.TIP_CONFIGURATIONS)

const getOverridingRevenueCenters = (
  venueSettings,
  revenueCenters
) => {
  const tipConfigurationSettingsNames =
    settingsUtils.getAllTipConfigurationSettingsNames()

  const tipConfigurationsSettings = venueSettings.filter((setting) =>
    tipConfigurationSettingsNames.includes(setting.name)
  )

  const activeTipConfigurationsSettings =
    tipConfigurationsSettings.filter(
      (setting) => setting.deactivatedAt === null
    )

  const standsSettings = settingsUtils.getSettingsForSpecificLevel(
    activeTipConfigurationsSettings,
    SETTINGS_LEVELS.standId
  )

  const standsSettingsStandIds = uniq(
    standsSettings.map((stand) => stand.standId)
  )

  return revenueCenters?.filter((revenueCenter) =>
    standsSettingsStandIds.includes(revenueCenter.id)
  )
}

export const venueSettingsUtils = {
  handleClickCustomTipConfiguration,
  getOverridingRevenueCenters,
}
